import videoSettingComponent from './video-settings';

export default angular.module('doxy.common.components.videoSettings.module', [
  videoSettingComponent,
]).name;
